export function isNoElementOnScreen(element) {
    let pageTop = $(window).scrollTop();
    let pageBottom = pageTop + $(window).height();
    let elementTop = $(element).offset().top;
    let elementBottom = elementTop + $(element).height();

    return !((pageTop < elementTop) && (pageBottom > elementBottom));
}